<template>
    <a-card
        :bordered="false" 
        class="header-solid h-full" 
    >
        <!-- style="background-color:#ebeced;" -->
        <template #title>
            <h6 class="font-semibold text-md mb-10" >{{ $t('form-page.technical-person') }} {{$n($vnode.key + 1)}}</h6>                  
            <div style="display:flex; flex-direction: row;">   
                <a-avatar
                    :size="112"
                    shape="square"
                    :src="profileImageUrl"
                    @click="onImageClick(profileImageUrl)"
                />
                
                <div style="margin-left: 20px;">
                    <h6 class="font-semibold mb-10" >{{ name }} {{type}}</h6>
                    <p style="font-weight: 600;"> {{ areaOfSpecialization }} </p>
                    <!-- <p style="font-weight: 600;"> {{ educationalQualification }} </p>
                    <p style="font-weight: 600;"> {{ educationalInstitution }} </p> -->
                </div>
            </div>
        </template>

        <!-- <template #extra>
            <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                <div class="ant-col ml-10" style="padding: 12px;">
                    <a-avatar
                        :size="74"
                        shape="square"
                        :src="signatureUrl"
                        @click="onImageClick(signatureUrl)"
                    />
                    <h6 class="font-semibold text-md mb-10">{{ $t('form-label.signature') }}</h6>
                </div>
            </div>
        </template> -->

        <!-- <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
            <div class="ant-col" style="padding: 12px;">
                <h6 class="font-semibold text-md mb-10" >{{ mobileNo }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ email }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ presentAddress }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ permanentAddress }}</h6>
            </div>
            <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                <h6 class="font-semibold text-md mb-0" >{{ date }}</h6>
                <p class="font-semibold text-muted mb-0">{{ dateCaption }}</p>
            </div>
        </div> -->

        <hr style="margin: 18px 0;border: none;height: 1px;background-color: #f5f5f5;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
        <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
            <div class="ant-col" style="padding: 12px;">
                <h6 class="font-semibold text-md mb-10" >{{ educationalQualification }}</h6>
                <h6 class="font-semibold text-md mb-10" >{{ educationalInstitution }}</h6>
            </div>
            <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                <a-avatar
                    :size="74"
                    shape="square"
                    :src="educationCertificateUrl"
                    @click="onImageClick(educationCertificateUrl)"
                />
                <!-- <h6 class="font-semibold text-md mb-10">{{ $t('form-label.e-certificate') }}</h6> -->
            </div>
        </div>
        
        <hr style="margin: 18px 0;border: none;height: 1px;background-color: #f5f5f5;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
        <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
            <div class="ant-col" style="padding: 12px;">
                <h6 class="font-semibold text-md mb-10">{{ membership }}</h6>
            </div>
            <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                <a-avatar
                    :size="74"
                    shape="square"
                    :src="membershipUrl"
                    @click="onImageClick(membershipUrl)"
                />
                <!-- <h6 class="font-semibold text-md mb-10">{{ $t('form-label.alter-nid') }}</h6> -->
            </div>
        </div>
         <hr style="margin: 18px 0;border: none;height: 2px;background-color: #06674a;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
        <CoolLightBox 
            :items="images" 
            :index="index"
            @close="index = null">
        </CoolLightBox>
    </a-card>
</template>

<script>
import { mapState } from "pinia";
import { useLocaleStore } from "../../../../../../stores/locale-store.js";
import { host } from "../../../../../../api/config.js";

import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
    name: "TechnicalPersonItem",
    components:{
        CoolLightBox
    },
    props: {
        individual: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            index: null
        };
    },
    computed:{
         images() {
            let arr = [];
            let img = this.profileImageUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.signatureUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.educationCertificateUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            img = this.membershipUrl;
            if (img && img.length > 0 && img.startsWith('http'))
                arr.push(img);
            return arr;
        },
         ...mapState(useLocaleStore, ['locale']),
        isLocal(){
            if (this.locale == "bn"){
                return "bn";
            }
            return "en";
        },
        profileImageUrl(){
            // console.log(this.individual);
            if (this.individual && this.individual.imageUrl && this.individual.imageUrl.length > 0){
                return host + this.individual.imageUrl;
            }
            return '/images/default-avatar.png';
        },
        name() {
            if (this.individual){
                if (this.isLocal == "bn" && this.individual.nameBn) {
                    return this.$t('form-label.name')  + " : " + this.individual.nameBn;
                }else if (this.isLocal == "en" && this.individual.nameEn) {
                    return this.$t('form-label.name') + " : " + this.individual.nameEn;
                }
            }
            return this.$t('form-label.name') + " : ";
        },
        type(){
            if (this.individual.type == "ARCHITECT"){
                return "(" + this.$t('radio-btn-caption.architect') + ")";
            }else if (this.individual.type == "ENGINEER"){
                return "(" + this.$t('radio-btn-caption.engineer') + ")";
            }else if (this.individual.type == "PLANNER"){
                return "(" + this.$t('radio-btn-caption.planner') + ")";
            }
            return "";
        },
        areaOfSpecialization(){
            if (this.individual && this.individual.areaOfSpecialization){
                return this.$t('form-label.specialization') + " : " + this.individual.areaOfSpecialization;
            }
            return this.$t('form-label.specialization') + " : ";
        },
        educationalQualification(){
            if (this.individual && this.individual.education){
                return this.$t('form-label.e-qualification') + " : " + this.individual.education;
            }
            return this.$t('form-label.e-qualification') + " : ";
        },
        educationalInstitution(){
            if (this.individual && this.individual.educationalInstitution){
                return this.$t('form-label.e-institution') + " : " + this.individual.educationalInstitution;
            }
            return this.$t('form-label.e-institution') + " : ";
        },
        educationCertificateUrl(){
            if (this.individual && this.individual.educationCertificateUrl && this.individual.educationCertificateUrl.length > 0){
                return host + this.individual.educationCertificateUrl;
            }
            return '/images/default-avatar.png';
        },
        membership(){
            if (this.individual && this.individual.membership){
                return this.$t('form-label.membership-number') + " : " + this.individual.membership;
            }
            return this.$t('form-label.membership-number') + " : ";
        },
        membershipUrl(){
             if (this.individual && this.individual.membershipUrl && this.individual.membershipUrl.length > 0){
                return host + this.individual.membershipUrl;
            }
            return '/images/nid-default.jpeg';
        },
        
    },
    methods:{
        onImageClick(url) {
            let index = this.images.findIndex(e => e == url);
            if (index > -1) {
                this.index = index;
            }
            
        }
    }
}
</script>

<style>

</style>